module.exports = __webpack_public_path__ + "static/img/20260429001.979d7fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/20260429001.jpg
// module id = 4O6h
// module chunks = 0